import type { PublicSlotKey } from '@/apilib';
import type { AnimationsApi } from './publicApi';

export const AnimationsApiKey: PublicSlotKey<AnimationsApi> = {
  name: 'AnimationsApi',
  public: true,
};
